import Phaser from 'phaser';
import GameConfig from './GameConfig';

export function createLevel(scene) {
  scene.textures.filterMode = Phaser.Scale.FIT;

  scene.inputKeys = scene.input.keyboard.addKeys({
    left:          Phaser.Input.Keyboard.KeyCodes.A,
    right:         Phaser.Input.Keyboard.KeyCodes.D,
    up:            Phaser.Input.Keyboard.KeyCodes.W,
    down:          Phaser.Input.Keyboard.KeyCodes.S,
    attack:        Phaser.Input.Keyboard.KeyCodes.J,
    jump:          Phaser.Input.Keyboard.KeyCodes.K,
    toggleMusic:   Phaser.Input.Keyboard.KeyCodes.Q,
    toggleMusicAlt: Phaser.Input.Keyboard.KeyCodes.I
  });

  scene.backgroundMusic = null;
  scene.isMusicPlaying = false;

  const map = scene.make.tilemap({ key: 'level0' });
  const tileset = map.addTilesetImage('FK_Sewer_Environment_SpriteSheet_01', 'env');
  const environmentLayer = map.createLayer(1, tileset, 0, 0).setScale(1);

  map.addTilesetImage('Power Ups', 'powerups');

  scene.cameras.main.setBounds(0, 0, map.widthInPixels, map.heightInPixels);
  scene.cameras.main.scrollX = 0;
  scene.cameras.main.scrollY = 0;
  scene.cameras.main.roundPixels = true;
  scene.cameras.main.setZoom(GameConfig.ZOOM_FACTOR);

  scene.physics.world.setBounds(0, 0, map.widthInPixels, map.heightInPixels, true, true, true, false);
  scene.pitDeathY = 530;

  environmentLayer.setCollisionByProperty({ collides: true });
  environmentLayer.setCollisionByProperty({ spikes: true });

  scene.environmentLayer = environmentLayer;

  return { map, environmentLayer };
}
